import * as Yup from "yup";

import { TextManager } from "Components/TextContext";
import { AkaFamilyAccidentProductIntroFormValues } from "./akaFamilyAccidentProductIntroInterfaces";

export const validationSchema =
  (): Yup.ObjectSchema<AkaFamilyAccidentProductIntroFormValues> => {
    const { getText } = TextManager;
    return Yup.object()
      .shape({
        hasProfessionalDisabilityCoverage: Yup.boolean().defined(),
        hasDeathCoverage: Yup.boolean().defined(),
        hasDisabilityCoverage: Yup.boolean()
          .when("hasDeathCoverage", {
            is: (hasDeathCoverage: boolean) => !hasDeathCoverage,
            then: (schema) =>
              schema.isTrue(
                getText(
                  "akafamilyaccidentform.validation.hasdisabilitycoverage",
                ),
              ),
          })
          .defined(),
      })
      .defined();
  };
